<template>
  <div id="user" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-6">
          <!-- <el-breadcrumb separator="/">
            <el-breadcrumb-item>tienda</el-breadcrumb-item>
            <el-breadcrumb-item>gestión de usuarios</el-breadcrumb-item>
          </el-breadcrumb> -->
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="filters">
      <div class="row">
        <div class="col-lg-2 col-md-6">
          <el-select
            v-model="search"
            clearable
            placeholder="Filtrar por"
            @change="
              params = { ...params, active: $event };
              getUsers();
            "
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-2 col-md-6">
          <el-input
            v-model="searchUser"
            placeholder="Buscar"
            clearable
            @change="
              params = { ...params, search: searchUser };
              getUsers();
            "
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="col-lg-8 col-md-12">
          <button
            class="btn btn_gradient"
            style="margin-right: 15px"
            @click="getUserById('new')"
          >
            Nuevo usuario
          </button>
          <button
            class="btn btn_secondary"
            style="width: auto; padding: 0px 10px"
            @click="getGeneratePassword()"
          >
            Cambiar contraseña general
          </button>
        </div>
      </div>
    </div>
    <div class="block">
      <el-table :data="users" style="width: 100%">
        <el-table-column label="PUNTO DE VENTA" width="auto" min-width="200px">
          <template slot-scope="scope">
            <span class="cell">{{
              scope.row.name ? scope.row.name : scope.row.socialDenomination
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="TELÉFONO"
          width="auto"
          min-width="150px"
        >
        </el-table-column>
        <el-table-column
          prop="town"
          label="POBLACIÓN"
          width="auto"
          min-width="150px"
        >
        </el-table-column>
        <el-table-column
          prop="email"
          label="EMAIL/USUARIO"
          width="auto"
          min-width="250px"
        >
        </el-table-column>
        <el-table-column label="ACTIVO" width="auto" min-width="100px">
          <template slot-scope="scope">
            <span class="cell">{{ scope.row.active ? "SI" : "NO" }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="ACCIONES" width="120">
          <template slot-scope="scope">
            <div
              class="d-inline-flex justify-content-around"
              style="width: 100%"
            >
              <img
                class="pointer"
                src="@/assets/icons/icon_edit.svg"
                @click="getUserById(scope.row.id)"
              />
              <img
                v-if="scope.row.id !== userLogged.id"
                class="pointer"
                src="@/assets/icons/icon_delete.svg"
                @click="
                  selectedUser = scope.row;
                  showModal = true;
                "
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="row pag">
        <div class="col-md-4 item arrows">
          <div class="d-flex align-items-center pointer" v-if="page > 1">
            <div
              @click="
                page = page > 2 ? page - 1 : 1;
                getUsers();
              "
            >
              <i class="el-icon-arrow-left"></i>
              <span>ANTERIOR</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 item">
          <el-pagination
            class="text-center"
            @size-change="getUsers()"
            @current-change="getUsers()"
            :current-page.sync="page"
            :page-size="pageSize"
            layout=" prev, pager, next"
            :total="totalUsers"
          >
          </el-pagination>
        </div>
        <div class="col-md-4 item arrows">
          <div
            class="d-flex justify-content-end align-items-center pointer"
            v-if="totalPage > 1 && page != totalPage"
          >
            <div
              @click="
                page = totalPage > page ? page + 1 : page;
                getUsers();
              "
            >
              <span>SIGUIENTE</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <br />
      <span class="secondary">
        MOSTRANDO {{ page }} - {{ totalPage }} de {{ totalUsers }} RESULTADOS
      </span>
    </div>
    <Modal
      v-if="showModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        showModal = false;
        titleModal = '';
      "
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            ¿Está seguro de que desea desactivar el usuario seleccionado?
          </label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="
              showModal = false;
              deleteUser(selectedUser.id);
            "
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
// Components
import { mapState } from "vuex";
import Modal from "@/components/Modal";

import AuthService from "@/services/auth.service";
import UserService from "@/services/user.service";
import Pagination from "@/model/Pagination";

export default {
  name: "Client",
  components: { Modal },
  data() {
    return {
      title: "GESTIÓN DE USUARIOS",
      showModal: false,
      users: [],
      totalUsers: 0,
      page: 1,
      pageSize: 5,
      totalPage: 0,
      search: "",
      searchUser: "",
      types: [
        { label: "Usuarios activos", value: true },
        { label: "Usuarios inactivos", value: false }
      ],
      // Active: true, false, or not present
      params: {},
      selectedUser: {}
    };
  },
  mounted() {
    this.sessionExpired();
    document.querySelector("#app").scrollTop = 0;
    this.getUsers();
  },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  methods: {
    sessionExpired() {
      AuthService.sessionExpired();
    },
    getUsers() {
      UserService.findAll(
        new Pagination(this.page - 1, this.pageSize, null),
        this.params
      )
        .then(response => {
          this.users = response.data.data.content;
          this.totalUsers = response.data.data.totalElements;
          this.totalPage =  response.data.data.totalPages;
        })
        .catch();
    },
    getUserById(path) {
      this.sessionExpired();
      this.$router.push("/new-user/" + path);
    },
    getGeneratePassword() {
      this.sessionExpired();
      this.$router.push("/admin-password/");
    },
    deleteUser(id) {
      UserService.deleteUser(id)
        .then(() => {
          this.getUsers();
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message: "Error eliminando usuario",
            type: "error",
            duration: 3000
          });
        });
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#user {
  width: 100%;
  height: auto;
  .filters {
    .el-select {
      width: 100%;
    }
  }
  .el-table {
    font-size: 20px;
    .el-table__header {
      th {
        background: $grey-white-color;
      }
    }
    td {
      padding: 25px 0px;
    }
    .cell {
      color: black;
      font-weight: 600;
    }
    img {
      width: 25px;
    }
  }
  .pag {
    margin: 0px;
    div.item {
      padding: 15px 0px;
      border-top: 1px solid $grey-dark-color;
      border-bottom: 1px solid $grey-dark-color;
      overflow: hidden;
      div {
        height: 100%;
        i {
          color: $grey-dark-color;
          font-size: 24px;
          font-weight: 600;
        }
        span {
          padding: 0px 10px;
        }
        .btn-prev,
        .btn-next {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  #user {
    .el-table {
      font-size: 20px;
    }
    .filters {
      .btn {
        margin-top: 20px !important;
      }
    }
  }
}

@media (max-width: 800px) {
  #user {
    .btn_secondary {
      width: 100% !important;
    }
  }
}

@media (max-width: 767px) {
  #user {
    .pag {
      div.item {
        &.arrows {
          display: none;
        }
        button {
          i {
            display: inline !important;
          }
        }
        .btn-prev,
        .btn-next {
          display: inline !important;
          color: $grey-dark-color !important;
        }
      }
    }
  }
}
</style>
